





















































































































import { Component, Watch, Prop } from "vue-property-decorator";
import WidgetBase from "../WidgetBase.vue";
import { DrawConfiguration } from "./drawConfiguration";
import { fabric } from "fabric";
import { DrawState } from "./drawState";
import randomstring from "randomstring";
import { Point } from "fabric/fabric-impl";
import ColorDialog from "./ColorDialog.vue";
import TextDialog from "./TextDialog.vue";
import { DrawOptions, TextOptions } from "../../../interfaces/drawOptions";
import ConfirmDeleteDialog from "@/components/customActions/ConfirmDeleteDialog.vue";
import { FileService } from "@/services/fileService";

@Component({ components: { ColorDialog, TextDialog, ConfirmDeleteDialog } })
export default class DrawWidget extends WidgetBase<DrawConfiguration> {
    @Prop() widgetHeight!: number;

    public canvas: fabric.Canvas | null = null;
    public colorSelectionActive: boolean = false;
    public textSelectionActive: boolean = false;
    public textOptions: TextOptions = { color: "#000000FF", size: 1, text: "" };

    public drawOptions: DrawOptions = { color: "#000000FF", thickness: 1 };
    public lastPosX: number = 0;
    public lastPosY: number = 0;
    public isDragging: boolean = false;
    public deleteDialogActive: boolean = false;

    // speeddial indicator
    public fab: boolean = false;

    public static get type() {
        return "draw";
    }

    public static get thumbnailAsset() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return require("@/assets/widget-thumbnails/pencil.svg");
    }

    public get speedDialButtons(): {
        color: string;
        icon: string;
        callback: Function;
        tooltip: string;
    }[] {
        return [
            {
                color: "primary",
                icon: "mdi-palette",
                callback: this.colorSelecting,
                tooltip: "widget.draw.colorSelect",
            },
            {
                color: "primary",
                icon: "mdi-draw",
                callback: this.activateDraw,
                tooltip: "widget.draw.drawMode",
            },
            {
                color: "primary",
                icon: "mdi-drag-variant",
                callback: this.activateDrag,
                tooltip: "widget.draw.dragMode",
            },
            {
                color: "primary",
                icon: "mdi-format-textbox",
                callback: this.textSelecting,
                tooltip: "widget.draw.textMode",
            },
            {
                color: "primary",
                icon: "mdi-upload",
                callback: this.startImport,
                tooltip: "widget.draw.upload",
            },
            {
                color: "primary",
                icon: "mdi-download",
                callback: this.downloadPng,
                tooltip: "widget.draw.download",
            },
            {
                color: "error",
                icon: "mdi-delete",
                callback: () => (this.deleteDialogActive = true),
                tooltip: "widget.draw.delete",
            },
        ];
    }
    public get zoom(): number {
        if (this.canvas) {
            return this.canvas.getZoom();
        } else return 1;
    }

    public get isDrawMode() {
        if (this.canvas) {
            return this.canvas.isDrawingMode || false;
        } else return false;
    }
    public set isDrawMode(newValue: boolean) {
        if (this.canvas) {
            this.canvas.isDrawingMode = newValue;
        }
    }

    public get selection() {
        if (this.canvas) {
            return this.canvas.getActiveObject();
        } else return false;
    }

    public get enableAutoFit(): boolean {
        if (this.$store.state.user && this.$store.state.userPreferences) {
            return this.$store.state.userPreferences.enableAutoFit;
        } else {
            return true;
        }
    }

    public set enableAutoFit(newValue: boolean) {
        // if (this.$store.state.user)
        this.$store.commit("setUserPreferences", {
            userPreferences: { enableAutoFit: newValue },
        });
    }

    public get drawLock() {
        const drawLock: boolean = this.config.state.drawLock;
        if (!this.isPresenter && drawLock) {
            if (this.canvas) {
                this.canvas.isDrawingMode = false;
            }
        }
        return drawLock;
    }
    public set drawLock(newValue: boolean) {
        this.update({
            config: this.config,
            payload: {
                drawLock: newValue,
            },
        });
    }

    public get isPresenter() {
        if (!this.$store.state.studio && this.$store.state.user) {
            return true;
        } else {
            return this.$store.getters.isPresenter;
        }
    }
    public setNewDrawOptions(newOptions: DrawOptions) {
        this.drawOptions = newOptions;
        if (this.canvas) {
            this.canvas.freeDrawingBrush.color = newOptions.color;
            this.canvas.freeDrawingBrush.width = newOptions.thickness;
        }
        this.colorSelectionActive = false;
    }

    public setNewTextOptions(newOptions: TextOptions) {
        this.textOptions = newOptions;
        if (this.canvas) {
            // hinzufügen zum canvas
            this.addTextbox();
        }
        this.textSelectionActive = false;
    }

    public mounted() {
        this.canvas = new fabric.Canvas(
            this.$refs.canvas as HTMLCanvasElement,
            {
                isDrawingMode: true,
                uniScaleTransform: true,
                selection: false,
                height: this.widgetHeight - 76,
                width: window.outerWidth - 12,
            }
        );

        this.canvas.freeDrawingBrush.color = this.drawOptions.color;
        this.canvas.freeDrawingBrush.width = this.drawOptions.thickness;

        if (this.config.state.objects) {
            this.onStateChange(this.config.state);
        }

        this.canvas.on("object:added", e => {
            if (e.target?.["isStateChange"]) {
                e.target["isStateChange"] = null;
                return;
            }

            this.$nextTick(() => {
                if (e.target) {
                    e.target["id"] = randomstring.generate();
                    e.target["version"] = 0;
                    this.update({
                        config: this.config,
                        payload: {
                            object: e.target.toJSON(["id", "version"]),
                            clear: false,
                        },
                    });
                }
            });
        });

        this.canvas.on("object:modified", e => {
            if (e.target?.["isStateChange"]) {
                e.target["isStateChange"] = null;
                return;
            }

            this.$nextTick(() => {
                if (e.target) {
                    let objects: fabric.Object[] = [];
                    if (e.target.type === "activeSelection") {
                        objects = e.target?.["_objects"];
                    } else {
                        objects = [e.target];
                    }
                    objects.forEach(obj => {
                        obj["id"] = obj["id"] || randomstring.generate();
                        obj["version"] += 1;
                        this.update({
                            config: this.config,
                            payload: {
                                object: obj.toJSON(["id", "version"]),
                                clear: false,
                            },
                        });
                    });
                }
            });
        });

        this.canvas.on("mouse:wheel", opt => {
            const e = opt.e as MouseWheelEvent;
            const delta = e.deltaY;
            if (this.canvas) {
                let zoom = this.canvas.getZoom();
                zoom *= 0.999 ** delta;
                if (zoom > 10) {
                    zoom = 10;
                }
                if (zoom < 0.1) {
                    zoom = 0.1;
                }
                this.canvas.zoomToPoint(
                    { x: e.offsetX, y: e.offsetY } as Point,
                    zoom
                );
                e.preventDefault();
                e.stopPropagation();
            }
        });

        this.canvas.on("mouse:down", opt => {
            const isLocked: boolean =
                this.config.state.drawLock && !this.isPresenter;

            const activeObject = this.canvas?.getActiveObject();
            if (activeObject) {
                activeObject.lockMovementX = isLocked;
                activeObject.lockMovementY = isLocked;
            }
            if (isLocked) {
                this.canvas?.discardActiveObject();

                return;
            }
            const e = opt.e as MouseEvent;
            if (
                this.canvas &&
                // this.canvas.selection &&
                (opt.target == null || e.shiftKey) &&
                !this.canvas.isDrawingMode &&
                !e.ctrlKey
            ) {
                this.isDragging = true;
                this.canvas.selection = false;

                this.lastPosX = e.clientX;
                this.lastPosY = e.clientY;
            }
        });

        this.canvas.on("mouse:move", opt => {
            const e = opt.e as MouseEvent;
            if (this.isDragging) {
                const vpt = this.canvas?.viewportTransform ?? null;
                if (vpt) {
                    vpt[4] += e.clientX - this.lastPosX;
                    vpt[5] += e.clientY - this.lastPosY;
                    this.canvas?.requestRenderAll();
                    this.lastPosX = e.clientX;
                    this.lastPosY = e.clientY;
                }
            }
        });
        this.canvas.on("mouse:up", () => {
            if (this.isDragging && this.canvas) {
                this.canvas.setViewportTransform(
                    this.canvas.viewportTransform ?? []
                );
                this.isDragging = false;
                // this.canvas.selection = true;
            }
        });

        this.resize();
    }

    public autoFitObject() {
        // client-only - except when saved in scriptbuilder
        // calculate zoom to fit selected object vertically
        if (this.canvas) {
            let panPoint: Point;
            const activeObject = this.canvas.getActiveObject();
            if (activeObject && activeObject.aCoords) {
                panPoint = new fabric.Point(
                    activeObject.aCoords.tl.x * this.zoom,
                    activeObject.aCoords.tl.y * this.zoom
                );
            } else {
                console.log(this.$t("widget.draw.autoFitMissing"));
                return;
            }
            this.canvas.absolutePan(panPoint);

            const vptpoints: {
                tl: fabric.Point;
                br: fabric.Point;
                tr: fabric.Point;
                bl: fabric.Point;
            } = this.canvas.calcViewportBoundaries();

            // height of viewport
            const hView =
                vptpoints.bl.y * this.zoom - vptpoints.tl.y * this.zoom;
            const hObj = activeObject.getBoundingRect(true).height;

            this.canvas.setZoom(hView / hObj);
        }
    }

    public activateDrag() {
        this.isDrawMode = false;
    }
    public activateDraw() {
        this.isDrawMode = true;
    }
    public colorSelecting() {
        if (this.canvas) {
            this.colorSelectionActive = !this.colorSelectionActive;
            // also set draw mode to active whenever the colorwheel gets called
            this.canvas.isDrawingMode = true;
        }
    }
    public textSelecting() {
        if (this.canvas) {
            this.textSelectionActive = !this.textSelectionActive;
            // also set draw mode to active whenever the colorwheel gets called
            this.canvas.isDrawingMode = false;
        }
    }

    public downloadPng() {
        if (this.canvas) {
            // var link = this.canvas.toDataURL();
            const link = document.createElement("a");
            link.href = this.canvas.toDataURL();
            link.download = "VIBRIX_" + new Date().toISOString() + ".png";
            link.click();
        }
    }

    public startImport() {
        (this.$refs.fileSelect as HTMLInputElement).click();
    }
    public handleImport(event: InputEvent) {
        const fileList = (event.target as HTMLInputElement).files;
        if (fileList && fileList.length > 0) {
            const file = fileList.item(0);
            if (file) {
                FileService.uploadFile(this.config.widgetId, file).then(res => {
                    fabric.Image.fromURL(
                        `/api/file/by_id/${res.data.id}`,
                        img => {
                            this.canvas?.add(img);
                        }
                    );
                });
            }
        }
    }

    public clearCanvas(confirmation: boolean) {
        if (this.canvas) {
            if (confirmation) {
                this.canvas.clear();
                this.$nextTick(() => {
                    this.update({
                        config: this.config,
                        payload: {
                            object: null,
                            clear: true,
                        },
                    });
                });
            }
        }
        this.deleteDialogActive = false;
    }

    public addTextbox() {
        if (this.canvas) {
            const textbox = new fabric.Textbox(this.textOptions.text, {
                width: 150,
                fontSize: this.textOptions.size,
                textAlign: "center",
                fill: this.textOptions.color,
            });
            this.canvas.add(textbox);
            textbox.viewportCenter();
            textbox.setCoords();

            // switch to drag mode
            this.canvas.isDrawingMode = false;
            this.canvas.renderAll();
        }
    }

    @Watch("config.state")
    public onStateChange(state: DrawState) {
        if (this.canvas) {
            const prevObjects = this.canvas.getObjects() ?? [];
            const missingObjects = state.objects?.filter(
                newObj =>
                    prevObjects.findIndex(
                        prevObj =>
                            prevObj["id"] == newObj["id"] &&
                            prevObj["version"] == newObj["version"]
                    ) == -1
            );

            const objectsToUpdate = missingObjects?.filter(newObj => {
                const oldObj = prevObjects.find(o => o["id"] == newObj["id"]);
                if (oldObj) {
                    return oldObj["version"] < newObj["version"];
                }
                return false;
            });
            const objectsToAdd = missingObjects?.filter(
                (newObj: fabric.Object) =>
                    prevObjects.findIndex(o => o["id"] == newObj["id"]) == -1
            );

            const objectsToRemove = prevObjects?.filter(
                (prevObj: fabric.Object) =>
                    state.objects.findIndex(
                        newObj => newObj["id"] == prevObj["id"]
                    ) == -1
            );

            // const outdatedReceivedObjects = missingObjects.filter(newObj => {
            //     const oldObj = prevObjects.find(o => o["id"] == newObj["id"]);
            //     if (oldObj) {
            //         return oldObj["version"] > newObj["version"];
            //     }
            //     return false;
            // });

            objectsToUpdate?.forEach((newObj: fabric.Object) => {
                const obj = prevObjects.find(
                    prevObj => prevObj["id"] == newObj["id"]
                );
                newObj["isStateChange"] = true;

                obj?.set(newObj);
            });

            fabric.util.enlivenObjects(
                objectsToAdd,
                (objects: fabric.Object[]) => {
                    objects.forEach((newObj: fabric.Object) => {
                        newObj["isStateChange"] = true;
                        this.canvas?.add(newObj);
                    });
                },
                "fabric"
            );

            objectsToRemove?.forEach((prevObj: fabric.Object) => {
                this.canvas?.remove(prevObj);
            });

            this.canvas.renderAll();
        }
    }

    public deleteSelected() {
        if (this.canvas) {
            const obj = this.canvas.getActiveObject();
            obj["version"] = -1;
            this.$nextTick(() => {
                this.update({
                    config: this.config,
                    payload: {
                        object: obj.toJSON(["id", "version"]),
                        clear: false,
                    },
                });
            });
        }
    }

    public resize(manualResize?: boolean) {
        if (!this.canvas) {
            return;
        }
        this.$nextTick(() => {
            const container = this.$refs.container as HTMLDivElement;
            setTimeout(() => {
                const rect = container.getBoundingClientRect();

                this.canvas?.setWidth(rect.width);
                this.canvas?.setHeight(rect.height);
                this.canvas?.renderAll();
                if (this.canvas) {
                    if (
                        this.enableAutoFit ||
                        (!this.enableAutoFit && manualResize)
                    ) {
                        const firstImg: fabric.Object = this.canvas.getObjects(
                            "image"
                        )[0];
                        if (firstImg) {
                            this.canvas._setActiveObject(firstImg);
                            this.autoFitObject();
                            this.canvas.discardActiveObject();
                        }
                    }
                }
            }, 800);
        });
    }
}
